module.exports = new __parcel__URL__("c1s13.3cb876fc.jpg").toString();